import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {experiences,experience} = api

/**
 * 查找
 */
export async function findExperiences(params) {
    return request({url: experiences, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createExperiences(params) {
    return request({url: experiences, method: 'post', data: params,})
}

/**
 * 更新
 */
export async function updateExperience(params) {
    return request({url: experience, method: 'put', data: params,})
}

/**
 * 删除
 */
export async function deleteExperience(params) {
    return request({url: experience, method: 'delete', data: params,})
}




// WEBPACK FOOTER //
// ./src/services/experience.js